import EdEdupad from '@/components/common/ed-edupad/ed-edupad';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import Quill from 'quill';
import { RequestProvider } from '@/shared/providers/request.provider';
import { EDUPAD_API } from '@/course-templates/values/course-templates.values';
import { setQuillInlineStyle } from '@/components/common/ed-collaborative-text-editor/formats/attributors';
import { _MEETINGS_STORE } from '@/meetings/values/meetings.values';
import * as _ from 'lodash';
import LRUCache from 'lru-cache';
import KEYS from '@/values/keys';


const MILESTONES_PER_FRAME = 7;
@Component({ name: 'ed-edupad-history'})
export default class EdEdupadHistory extends EdEdupad {

  /* Props */
  @Prop() readonly params : any;
  @Ref() readonly restoring: any;
  // public viewerId: string = 'viewer-' + this.dynamicId;

  public lastVersion : number = 1;
  public selectedVersion : number = 1;
  public versionsLabels = [];
  private isLoading : boolean = true;

  public byMilestones : boolean = false;
  public milestones : any[] = [];
  public milestoneLabels = []
  public totalMilestones = 0;
  public selectedMilestone : number = 1;
  public modelValue : any;
  public isloadingMilestones : boolean = true;
  public showTooltip = false;

  public modalMessage : any = '';
  public modalTitle : any = '';
  
  private versionViewer: any = {};
  private context = process.env.VUE_APP_EDUAC_PAD_CONTEXT ? `${process.env.VUE_APP_EDUAC_PAD_CONTEXT}/` : '' 
  private fetchedVersions: LRUCache<number, any> = new LRUCache({max: 100});

  get collection () {
    return this.params.collection;
  }

  get documentId () {
    return this.params.documentId;
  }

  get title () {
    return this.params.title;
  }
  
  get allowRestore(){
    return this.selectedVersion < this.lastVersion
  }

  get viewerId(){
    return  'viewer-' + this.dynamicId;
  }
  get loading(){
    return this.isLoading ? 'var(--ed-color-green)' : false
  }

  get loadingMilestones(){
    return this.isloadingMilestones ? 'var(--ed-color-green)' : false
  }

  get historyTitle() {
    return this.title ? this.title  : this.$t('edupad.historyTitle')
  }

  get sliderContentStyle(){
    if(this.byMilestones == true && this.totalMilestones > 8)
        return `width: ${this.totalMilestones * 100}px`; 
    return 'width: 100%';
  }
  
  public async onOpenVersionHistory(){
    this.isLoading = true;
    let editor = document.getElementById(this.viewerId)
    setQuillInlineStyle();
    this.versionViewer = new Quill(editor, {
                                  modules: { toolbar: null },
                                  readOnly: true,
                                  theme: 'snow',
                                  placeholder: this.$t('edupad.loadingHistory') as string,
                                });
    try{
      let req = this.context + EDUPAD_API.GET_LATEST
        .replace('{collection}', this.collection)
        .replace('{documentId}', this.documentId);
      let latest = await RequestProvider.requestEdupad('GET', req)
      if( latest.v === 0){
          this.error(this.$t('errors.ups'), this.$t('edupad.noHistory'))
      } else {
        this.lastVersion = latest.v
        this.selectedVersion = latest.v
        this.fetchedVersions.set(latest.v, latest.data);
        this.buildTickLabels();
        this.versionViewer.setContents(latest.data);
        this.focus()
      }
    } catch (error) {
      this.error(this.$t('errors.ups'), this.$t('edupad.errorHistory'))
    }    
    this.isLoading = false;
  }
    
  public closeVersionHistory(){
    this.$EdModal.closeBootstrapModal();
  }

  public async viewVersion(){ 
    const _version = this.selectedVersion;
    const data =  this.fetchedVersions.get(_version)
    if(data){
      this.versionViewer.setContents(data);
    } else {
      this.isLoading = true;
      try{
        let req = this.context + EDUPAD_API.GET_VERSION
                .replace('{collection}', this.collection)
                .replace('{documentId}', this.documentId)
                .replace('{versionNumber}', `${_version}`);
        let fetched = await RequestProvider.requestEdupad('GET', req)
        if(fetched.v === _version){
          this.versionViewer.setContents(fetched.data);
          this.fetchedVersions.set(_version, fetched.data);
        } else {
          this.error(this.$t('errors.ups'), this.$t('edupad.errorHistoryVersion', {version: _version}))
        }
      } catch (error) {
        this.error(this.$t('errors.ups'), this.$t('edupad.errorHistory'))
      } 
      this.isLoading = false;   
    }
  }
    

  public viewMilestone(){
    this.selectedVersion = this.milestones[this.selectedMilestone].version;
    this.showTooltip = true;
    this.viewVersion()
    this.syncSliderScroll()
  }

  public prevVersion(){
    if(this.byMilestones){
      if(this.selectedMilestone > 0 ){
        this.selectedMilestone--;
        this.viewMilestone();
      }        
    } else if(this.selectedVersion > 1 ){
      this.selectedVersion--;
      this.viewVersion()
    }
  }

  public nextVersion(){
    if(this.byMilestones){
      if(this.selectedMilestone < this.totalMilestones ){
        this.selectedMilestone++;
        this.viewMilestone();
      }
    } else if(this.selectedVersion < this.lastVersion ){
      this.selectedVersion++;
      this.viewVersion()
    }
  }

  private buildTickLabels(){
    this.versionsLabels = [];
    let currentVersion = this.lastVersion;
    if(currentVersion > 10){
      const middle = Math.floor(currentVersion * 0.5);
      const fQuarter = Math.floor(currentVersion * 0.25);
      const tQuarter = Math.floor(currentVersion * 0.75);
      this.versionsLabels[0] = '1';
      this.versionsLabels[currentVersion-1] = `${currentVersion}`;
      this.versionsLabels[middle-1] = `${middle}`;
      this.versionsLabels[fQuarter-1] = `${fQuarter}`;
      this.versionsLabels[tQuarter-1] = `${tQuarter}`; 
    } else {
      for(let idx = 1; idx <= currentVersion; idx++)
        this.versionsLabels[idx-1] = `${idx}`;
    }
  }

  public async onByMilestones(){
    if(this.byMilestones == true){
      this.isloadingMilestones = true;
      await this.getMilestones();
      this.viewMilestone();
      this.isloadingMilestones = false;
    } else {
      this.viewVersion();
      this.showTooltip = false
    }  
    this.focus();
  }

  public focus(){
    // @ts-ignore
    this.$refs['ed-edupad-history'].focus();
  }

  public getMilestoneVersion(milestone : number){
    if(this.milestones.length > 0)
      return this.milestones[milestone].version
    return 0;
  }

  public getMilestoneInfo(){
    if(this.byMilestones  && this.milestones.length > 0)
      return this.milestones[this.selectedMilestone].info
    return '';
  }

  private async getMilestones(){
    let req = this.context + EDUPAD_API.GET_VERSIONS
              .replace('{collection}', this.collection)
              .replace('{documentId}', this.documentId)
              ;
    try {
      this.milestoneLabels = [];
      let versions = await RequestProvider.requestEdupad('GET', req)
      versions = _.orderBy(versions, ['version'],['asc'])

      this.totalMilestones = 0;
      this.milestones[this.totalMilestones] = {version: 1, action: `${this.$t('edupad.milestoneInitial')}`, info: `${this.$t('edupad.milestoneInitial')}`}
      let last = 0;
      versions.forEach(milestone => {
        let info = '';
        let label = '';
        switch(milestone.metadata.triggeringAction){
          case 'autosave':
            info =  `${this.$t('edupad.milestoneAutosave', { date: new Date(milestone.metadata.timestamp).toLocaleString() })}`;
            label = `${this.$t('edupad.milestoneAutosaveLabel')}`;
            break;
          case 'overwrite':
            info = `${this.$t('edupad.milestoneOverride', { date: new Date(milestone.metadata.timestamp).toLocaleString(), user: milestone.metadata.triggeredBy })}`;
            label = `${this.$t('edupad.milestoneOverridedLabel')}`;
            break;
          case 'restored':
            info = `${this.$t('edupad.milestoneRestore', { date:new Date( milestone.metadata.timestamp).toLocaleString(), user: milestone.metadata.triggeredBy})}`;
            label = `${this.$t('edupad.milestoneRestoredLabel')}`;
            break;
        }
        this.milestones[++this.totalMilestones] = { version: milestone.version, action: label, info}
        last = milestone.version
      }); 

      if(this.lastVersion !== last){
        this.milestones[++this.totalMilestones] = {version: this.lastVersion, action: `${this.$t('edupad.milestoneCurrent')}`, info: `${this.$t('edupad.milestoneCurrent')}`}
      }
      this.milestoneLabels = this.milestones.map(m => m.action)
      this.selectedMilestone = this.totalMilestones;

      setTimeout(()=> this.syncSliderScroll(), 100);
    } catch (error) {
      this.error(this.$t('courses.errors.errorTitle'), this.$t('edupad.erroLoadingMilestones'))
    }    
  }

  public syncSliderScroll() {
    // @ts-ignore
    const maxScroll = this.$refs.sliderContainer.scrollWidth;           //Max pixels available to scroll
    // @ts-ignore
    const curScroll = this.$refs.sliderContainer.scrollLeft;            //Current scroll pixels position
    const pxByMilestone = Math.trunc(maxScroll / this.totalMilestones); //How many pixesl are availabe for each milestone
    const windowSize = pxByMilestone * MILESTONES_PER_FRAME;            //The visible area 
    const curPosition = this.selectedMilestone * pxByMilestone;         //Expected position according selected milestone
    
    let scrollLeft = 0;
    let scrollWindow = [0, windowSize]
    
    //Calculate the visible scroll window
    if(curScroll === 0)  
        scrollWindow = [0, Math.min(maxScroll, windowSize)]
     else if(curScroll === maxScroll)
        scrollWindow = [Math.max(0, maxScroll - windowSize) , maxScroll]
     else 
        scrollWindow = [curScroll, Math.min(maxScroll, curScroll + windowSize)]
    

    //Calculate the scroll position
    if(this.totalMilestones === this.selectedMilestone){ 
      scrollLeft = maxScroll;       //When selected milestone is the last, move scroll to max position
    } else {
      const leftBound = scrollWindow[0] + pxByMilestone;
      if(curPosition >= leftBound && curPosition <= (scrollWindow[1])){
        this.syncDetails();
        return;                     //When expected position is in visible window, do not move scroll
      }  
      if(curPosition > leftBound){
        scrollLeft =  curScroll + pxByMilestone;
      } else {
        scrollLeft = curScroll - pxByMilestone; 
      }
    }
    // @ts-ignore
    this.$nextTick(() => this.$refs.sliderContainer.scrollLeft = scrollLeft);
    this.syncDetails();
  }

  private syncDetails(){
    setTimeout(() => {
      const tooltip = document.querySelector('.ed-tooltip > span:nth-child(1)');
      if (tooltip) {
        const subtitle = document.querySelector('.ed-slider__thumb-label')
        const left = subtitle.getBoundingClientRect().left - (this.selectedMilestone == 0 || this.selectedMilestone == this.totalMilestones ? 0 : 100);
        // @ts-ignore
        this.$nextTick(() => tooltip.style.left = `${left}px`);
      }
    }, 100);
  }

  public restoreVersion(){
    this.modalTitle = this.$t('common.pleaseConfirm')
    this.modalMessage = this.$t('edupad.confirmRestore');
    this.$EdModal.createConfirmationModal({
      title: this.modalTitle,
      body: this.modalMessage, 
      onFront: true,
      type: KEYS.EVENT_TYPES.WARNING,
      actions: [
        {
          label : this.$t('common.cancel'),
          mode  : 'outline',
        },
        {
          label : this.$t('common.accept'),
          action: this.doRestoreVersion
        },
      ]
    });
  }

  public async doRestoreVersion(){
    if (this.restoring) 
      this.restoring['show'](this.$t('edupad.restoring', {version:this.selectedVersion}).toString());
    
    let req = this.context + EDUPAD_API.RESTORE_VERSION
              .replace('{collection}', this.collection)
              .replace('{documentId}', this.documentId)
              .replace('{versionNumber}', String(this.selectedVersion))
              ;
    try {
      await RequestProvider.requestEdupad('PUT', req)
    } catch (error) {
      this.error(this.$t('courses.errors.errorTitle'), this.$t('edupad.errorRestoring'))
    }
    if (this.restoring) 
      this.restoring['hide']();
    this.closeVersionHistory();
  }

  private error(title : any, message : any){
    this.modalTitle = title;
    this.modalMessage = message;
    this.$EdModal.createMessageModal({
      title: this.modalTitle,
      body: this.modalMessage, 
      onFront: true,
      type: KEYS.EVENT_TYPES.DANGER,
      actions: [
        {
          label : this.$t('common.accept')
        }
      ]
    });
  }

  /* Hooks */
  mounted() {
    this.onOpenVersionHistory();
    setTimeout(() => {
      this.getMilestones();
    }, 800);
  }
}
